/* eslint-disable max-len */
import EDC from '../../../shared/globals';
import Chick from '../animations/chick';
import ChickenAndDuck from '../animations/chicken-duck';
import Butterfly from '../animations/butterfly';
import Squirrel from '../animations/squirrel';
import Rabbit from '../animations/rabbit';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';

EDC.Games.CountAlong.Scenes.Main = function () {
  BaseMinigamesMain.apply(this, [EDC.Games.CountAlong, 44]);
  this.gameConfig = store.getters['games/getGameById']().sets[0].config;
  this.gameData = EDC.Games.CountAlong.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.numbers = [];
  this.animals = [];
  this.animalList = {
    0: 'chicken',
    1: 'butterfly2',
    2: 'squirrel',
    3: 'butterfly1',
    4: 'duck',
    5: 'rabbit',
    6: 'chick',
  };
  this.frozenAnimals = [];
  this.frozenNumbers = [];
};

EDC.Games.CountAlong.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.CountAlong.Scenes.Main.prototype.constructor = EDC.Games.CountAlong.Scenes.Main;

const CA = EDC.Games.CountAlong.Scenes.Main.prototype;

CA.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

CA.createTemplateUI = function () {
  this.add.sprite(310, 200, 'title').setScale(0.95);
  this.add.sprite(1360, 210, 'question').setScale(0.95);

  const hitArea = this.add.container(950, 1030);
  hitArea.setSize(1500, 200);
  hitArea.setInteractive();
  this.cursorManager.setDefaultDraggableEvents(hitArea);
};

CA.loadIteration = function () {
  this.createNumbers();
  this.addAnimals();
};

CA.createNumbers = function () {
  for (let i = 0; i < 10; i++) {
    const x = 288 + i * 150;
    const y = 1000;
    const numberContainer = this.add.container(x, y);
    const number = this.add.sprite(-3, 0, `answer-${i}`);
    numberContainer.numberText = i;
    numberContainer.add(number);
    const markAnim = new AnswerMark(this, numberContainer).setScale(0.25);
    numberContainer.setData('markAnim', markAnim);
    numberContainer.setSize(125, 150);
    numberContainer.setInteractive();
    this.cursorManager.setDefaultDraggableEvents(numberContainer);
    numberContainer.on('pointerup', this.checkAnswer.bind(this, numberContainer), this);
    this.numbers.push(numberContainer);
  }
};

CA.checkAnswer = function (numberContainer) {
  const correctNumber = this.gameConfig.sets[this.difficulty].iterations[this.iteration].animalCount;
  if (numberContainer.numberText === correctNumber) {
    this.playCorrect();
    numberContainer.getData('markAnim').showMark(true, () => {});
    this.time.delayedCall(2000, this.nextIteration, [], this);
  } else {
    numberContainer.getData('markAnim').showMark(false, () => {});
    numberContainer.disableInteractive();
    this.playWrong();
    this.disableFreeze();
    numberContainer.first.setTint(0xff0000);
  }
};

CA.shuffleAnimals = function () {
  return Object.keys(this.animalList).sort(() => Math.random() - 0.5);
};

CA.addAnimals = function () {
  const { animalCount } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const animals = this.shuffleAnimals();
  let iterations = 0;
  let animalNumber = 0;
  let resetNumber = 0;
  while (iterations < animalCount) {
    if (iterations > 6) {
      animalNumber = resetNumber;
      resetNumber += 1;
    }
    const { x, y } = this.getAnimalPosition(iterations);
    const animal = this.physics.add.sprite(x, y, this.animalList[animals[animalNumber]]);
    animal.animalName = this.animalList[animals[animalNumber]];
    animal.setInteractive();
    this.cursorManager.setDefaultDraggableEvents(animal);
    animal.moveAnim = this.moveAnimal(animal);
    animal.moveAnim.start();
    animal.on('pointerup', this.freezeAnimal.bind(this, animal), this);
    this.animals.push(animal);
    animalNumber += 1;
    iterations += 1;
  }
  this.animals.map((animal) => {
    if (animal.animalName === 'butterfly1' || animal.animalName === 'butterfly2') {
      animal.setDepth(1);
    }
    return true;
  });
  this.startCollision();
};

CA.startCollision = function () {
  for (let i = 0; i < this.animals.length; i++) {
    const otherAnimals = this.animals.filter((x, index) => index !== i);
    if (this.animals[i].animalName !== 'butterfly1' && this.animals[i].animalName !== 'butterfly2') {
      for (let j = 0; j < otherAnimals.length; j++) {
        if (otherAnimals[j].animalName !== 'butterfly1' && otherAnimals[j].animalName !== 'butterfly2') {
          this.physics.add.collider(this.animals[i], otherAnimals[j], this.reverse, null, this);
        }
      }
    }
  }
};

CA.reverse = function (animal1, animal2) {
  animal1.moveAnim.changeSpeed();
  animal2.moveAnim.changeSpeed();
  animal1.toggleFlipX();
  animal2.toggleFlipX();
};

// eslint-disable-next-line consistent-return
CA.moveAnimal = function (animal) {
  const name = animal.animalName;
  if (name === 'rabbit') {
    return new Rabbit(this, animal);
  }
  if (name === 'squirrel') {
    return new Squirrel(this, animal);
  }
  if (name === 'butterfly1' || name === 'butterfly2') {
    return new Butterfly(this, animal);
  }
  if (name === 'chicken' || name === 'duck') {
    return new ChickenAndDuck(this, animal);
  }
  if (name === 'chick') {
    return new Chick(this, animal);
  }
};

CA.freezeAnimal = function (animal) {
  this.frozenAnimals.push(animal);
  animal.moveAnim.stop();
  animal.disableInteractive();
  const number = this.add
    .sprite(animal.x - 30, animal.y - 100, `number-${this.frozenAnimals.length}`)
    .setDepth(1)
    .setScale(0.5);
  this.frozenNumbers.push(number);
};

CA.getAnimalPosition = function (i) {
  const animalPosition = {
    0: {
      x: 300,
      y: 630,
    },
    8: {
      x: 600,
      y: 630,
    },
    2: {
      x: 900,
      y: 630,
    },
    7: {
      x: 1150,
      y: 630,
    },
    5: {
      x: 1400,
      y: 630,
    },
    4: {
      x: 770,
      y: 880,
    },
    6: {
      x: 1085,
      y: 880,
    },
    3: {
      x: 1650,
      y: 880,
    },
    1: {
      x: 1350,
      y: 880,
    },
  };
  return animalPosition[i];
};

CA.disableFreeze = function () {
  this.frozenAnimals.map((x) => {
    x.setInteractive();
    x.moveAnim.resume();
    return true;
  });
  this.frozenNumbers.map((x) => {
    x.destroy();
    return true;
  });
  this.frozenAnimals = [];
  this.frozenNumbers = [];
};

CA.nextIteration = function () {
  this.animals.map((x) => {
    x.moveAnim.delete();
    x.destroy();
    return true;
  });
  this.frozenNumbers.map((x) => {
    x.destroy();
    return true;
  });
  this.numbers.map((x) => {
    x.destroy();
    return true;
  });
  this.animals = [];
  this.frozenNumbers = [];
  this.numbers = [];
  this.frozenAnimals = [];
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

export default EDC.Games.CountAlong.Scenes.Main;
